module.exports = "../dist/frontend/icons/cards/white.svg?909cbf5d8ec729e1697f7e974cd7a7f4";